import { render, staticRenderFns } from "./checkout-option.vue?vue&type=template&id=49036d74&scoped=true"
import script from "./checkout-option.vue?vue&type=script&lang=js"
export * from "./checkout-option.vue?vue&type=script&lang=js"
import style0 from "./checkout-option.vue?vue&type=style&index=0&id=49036d74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49036d74",
  null
  
)

export default component.exports